import { IconType } from 'react-icons'
import IconButton from 'src/components/IconButton'

interface TechStacks {
  lang: string[]
  icons: IconType[]
  description: string
}

interface TechStackProps {
  techStacks: TechStacks
}

const TechStack: React.FC<TechStackProps> = ({ techStacks }) => {
  return (
    <div className='flex max-md:flex-col gap-30 pb-50 border-b border-silverMedal  dark:border-jet mb-50 '>
      <h2 className='w-40 max-md:w-full font-archivo text-blackHole font-normal text-18 dark:text-white'>
        Tech Stacks
      </h2>
      <div className='w-53 max-md:w-full flex flex-col gap-30'>
        <div className='flex flex-wrap gap-16 w-96'>
          {techStacks.icons.map((IconComponent, index) => {
            const Icon = IconComponent as React.ComponentType
            return (
              <div key={index} className='text-[20px]'>
                <IconButton
                  title={techStacks.lang[index]}
                  icon={<Icon />}
                  darkIcon={<Icon />}
                  className='iconButton font-archivo'
                />
              </div>
            )
          })}
        </div>
        <div className='font-archivo text-black text-14 dark:text-whiteGrey'>{techStacks.description}</div>
      </div>
    </div>
  )
}

export default TechStack
